import { SafePromise } from '@benzinga/safe-await';
import { Session } from '@benzinga/session';

import { RestfulClient } from '@benzinga/session';
import { CalendarDataParameters, CalendarEvents } from '../entities';
import { createCalendarUrl } from '../generateRestfulParams';
import { CalendarEnvironment } from '../environment';

export class CalendarsEventsRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(CalendarEnvironment).url, session);
  }

  public fetchEvents = async (
    parameters: CalendarDataParameters,
    session: Session,
    pagesize: number,
  ): SafePromise<CalendarEvents[]> => {
    const url = new URL(createCalendarUrl(parameters, session, pagesize));
    return await this.get(url, {
      timeout: 30000,
    });
  };
}
